import { render, staticRenderFns } from "./DashboardRevisorAprobador.vue?vue&type=template&id=254ec684"
import script from "./DashboardRevisorAprobador.vue?vue&type=script&lang=js"
export * from "./DashboardRevisorAprobador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports